import { render } from "./RutinePage.vue?vue&type=template&id=8d4e3b0a"
import script from "./RutinePage.vue?vue&type=script&lang=js"
export * from "./RutinePage.vue?vue&type=script&lang=js"

import exportComponent from "/home/farena/workspace/smt/smt_app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__